/**
 * Ключ перевода текста реестра экранов (agroai-wo4, журнал №1850).
 *
 * Реестр (`pages.ts`, `catalog/*.ts`) пишется по-русски: его читает модель, и
 * сервер отдаёт панели те же русские строки (заголовки и тексты шагов тура,
 * названия блоков). Человеку они показываются на языке интерфейса — переводом
 * на клиенте, в момент показа (`surfaceText.ts`). Сообщение каталога ищется по
 * САМОМУ русскому тексту: id = вид + хеш текста. Поэтому правка русского текста
 * даёт новый id — узбекский перевод старого текста становится «ключом без
 * источника», и `npm run i18n:check` падает, а не показывает тихо устаревший
 * перевод.
 *
 * Модуль без импортов: его читает и браузер, и `scripts/build-ai-surface.mjs`
 * (Node без сборки), — хеш и «первая фраза» обязаны совпадать у обоих.
 */

/** Вид текста: назначение экрана (текст шага тура), название блока, первая фраза описания блока, пункт меню. */
export type SurfaceKind = 'purpose' | 'title' | 'lead' | 'menu';

/** Пробелы сведены к одному: сервер так же сжимает текст шага (`ui_tools._text`). */
export function squash(text: string): string {
  return text.replace(/\s+/g, ' ').trim();
}

/** FNV-1a 32 бита по кодовым единицам UTF-16, base36: детерминированно в Node и браузере. */
function fnv1a(text: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(36).padStart(7, '0');
}

/** Id сообщения каталога `surface` для текста реестра: `surface.title.0k3x9qa`. */
export function surfaceId(kind: SurfaceKind, text: string): string {
  return `surface.${kind}.${fnv1a(squash(text))}`;
}

/** Первая фраза описания блока (полное — во всплывающей подсказке на языке-источнике). */
export function firstSentence(text: string): string {
  const end = /(?<!\d)[.!?](?=\s+[А-ЯЁA-Z«]|$)/g;
  for (let m = end.exec(text); m; m = end.exec(text)) if (m.index >= 40) return text.slice(0, m.index + 1);
  return text;
}
